export const hotelTouristMonthlySection = [
    {
        title: {
            hi: "भारतीय पर्यटक विवरण (राज्य अनुसार)",
            en: "Indian Tourist Details (State-wise)",
        },
        fields: [
            {
                inputProps: {
                    type: "table",
                    name: "indian_tourist_details",
                    headers: [
                        {
                            label: { hi: "राज्य", en: "State" },
                            name: "state",
                            type: "select",
                            options: [

                            ],
                            validation: {
                                required: true,
                                message: {
                                    hi: "राज्य चुनें",
                                    en: "Select state",
                                },
                            },
                        },
                        {
                            label: { hi: "पर्यटकों की संख्या", en: "Number of Tourists" },
                            name: "number_of_tourists",
                            type: "number",
                            validation: {
                                required: true,
                                message: {
                                    hi: "पर्यटकों की संख्या दर्ज करें",
                                    en: "Enter number of tourists",
                                },
                            },
                        },
                        {
                            label: { hi: "बेड नाइट्स", en: "Bed Nights" },
                            name: "bed_nights_spent",
                            type: "number",
                            validation: {
                                required: true,
                                message: {
                                    hi: "बेड नाइट्स दर्ज करें",
                                    en: "Enter bed nights",
                                },
                            },
                        },
                    ],
                    rows: [{ state: "", number_of_tourists: "", bed_nights_spent: "" }],
                },
            },
            {
                divClass: "w-full lg:w-1/4 px-2 mb-4",
                label: {
                    hi: "कुल मासिक भारतीय पर्यटक",
                    en: "Total Monthly Indian Tourists",
                },
                htmlFor: "monthy_total_tourists_indian",
                inputProps: {
                    type: "number",
                    name: "monthy_total_tourists_indian",
                    min: 0,
                    validation: {
                        required: true,
                        message: {
                            hi: "कुल मासिक भारतीय पर्यटकों की संख्या दर्ज करें",
                            en: "Enter total monthly Indian tourists",
                        },
                    },
                },
            },
            {
                divClass: "w-full lg:w-1/4 px-2 mb-4",
                label: {
                    hi: "भारतीय पर्यटकों द्वारा प्रति माह बिताई गई रातें",
                    en: "Monthly Nights Spent by Indian Tourists",
                },
                htmlFor: "monthy_nghts_spent_indian",
                inputProps: {
                    type: "number",
                    name: "monthy_nghts_spent_indian",
                    min: 0,
                    validation: {
                        required: true,
                        message: {
                            hi: "भारतीय पर्यटकों द्वारा बिताई गई रातों की संख्या दर्ज करें",
                            en: "Enter nights spent by Indian tourists",
                        },
                    },
                },
            },
        ],
    },
    {
        title: {
            hi: "विदेशी पर्यटक विवरण (देश अनुसार)",
            en: "Foreigner Tourist Details (Country-wise)",
        },
        fields: [
            {
                inputProps: {
                    type: "table",
                    name: "foreigner_tourist_details",
                    headers: [
                        {
                            label: { hi: "देश", en: "Country" },
                            name: "country",
                            type: "select",
                            options: [

                            ],
                            validation: {
                                required: true,
                                message: {
                                    hi: "देश चुनें",
                                    en: "Select country",
                                },
                            },
                        },
                        {
                            label: { hi: "पर्यटकों की संख्या", en: "Number of Tourists" },
                            name: "number_of_tourists",
                            type: "number",
                            validation: {
                                required: true,
                                message: {
                                    hi: "पर्यटकों की संख्या दर्ज करें",
                                    en: "Enter number of tourists",
                                },
                            },
                        },
                        {
                            label: { hi: "बेड नाइट्स", en: "Bed Nights" },
                            name: "bed_nights_spent",
                            type: "number",
                            validation: {
                                required: true,
                                message: {
                                    hi: "बेड नाइट्स दर्ज करें",
                                    en: "Enter bed nights",
                                },
                            },
                        },
                    ],
                    rows: [{ country: "", number_of_tourists: "", bed_nights_spent: "" }],
                },
            },
            {
                divClass: "w-full lg:w-1/4 px-2 mb-4",
                label: {
                    hi: "कुल मासिक विदेशी पर्यटक",
                    en: "Total Monthly Foreigner Tourists",
                },
                htmlFor: "monthy_total_tourists_foreigner",
                inputProps: {
                    type: "number",
                    name: "monthy_total_tourists_foreigner",
                    min: 0,
                    validation: {
                        required: true,
                        message: {
                            hi: "कुल मासिक विदेशी पर्यटकों की संख्या दर्ज करें",
                            en: "Enter total monthly foreigner tourists",
                        },
                    },
                },
            },
            {
                divClass: "w-full lg:w-1/4 px-2 mb-4",
                label: {
                    hi: "विदेशी पर्यटकों द्वारा प्रति माह बिताई गई रातें",
                    en: "Monthly Nights Spent by Foreigner Tourists",
                },
                htmlFor: "monthy_nghts_spent_foreigner",
                inputProps: {
                    type: "number",
                    name: "monthy_nghts_spent_foreigner",
                    min: 0,
                    validation: {
                        required: true,
                        message: {
                            hi: "विदेशी पर्यटकों द्वारा बिताई गई रातों की संख्या दर्ज करें",
                            en: "Enter nights spent by foreigner tourists",
                        },
                    },
                },
            },
        ],
    },
];

export const validateTableFields = (sections, formData) => {
    const errors = {};
    let isValid = true;

    sections.forEach((section) => {
        section.fields.forEach((field) => {
            if (field.inputProps.type !== "table") return;

            const tableName = field.inputProps.name;
            const rows =
                Array.isArray(formData[tableName]) && formData[tableName].length > 0
                    ? formData[tableName]
                    : field.inputProps.rows
            const headers = field.inputProps.headers;

            rows.forEach((row, rowIndex) => {
                headers.forEach((header) => {
                    const value = row[header.name];

                    if (
                        header.validation?.required &&
                        (value === "" || value === undefined)
                    ) {
                        errors[`${tableName}.${rowIndex}.${header.name}`] =
                            header.validation.message;
                        isValid = false;
                    }
                });
            });
        });
    });

    return { errors, isValid };
};

export const validateFormData = (sections, formData) => {
    const errors = {};

    sections.forEach((section) => {
        section.fields.forEach((field) => {
            if (field.inputProps.type === "table") return;

            const name = field.inputProps.name;
            const validation = field.inputProps.validation;
            const value = formData[name];

            if (validation?.required && (value === "" || value === undefined)) {
                errors[name] = validation.message;
            }
        });
    });

    return { errors, isValid: Object.keys(errors).length === 0 };
};

export const camelCaseToLabel = (str) => {
    if (!str) return "";

    return str
        .replace(/([A-Z])/g, " $1") // Insert space before capital letters
        .replace(/^./, (char) => char.toUpperCase()); // Capitalize first letter
};

/**
 * Validates a single field
 */
export const validateField = (validation, value, label) => {
    if (!validation) return null;

    // Handle required validation
    if (validation.required) {
        if (typeof value === "object" && value !== null) {
            // For document/file fields → check url
            if (!value.url) {
                return `${label} is required`;
            }
        } else if (!value) {
            // For text/number fields
            return `${label} is required`;
        }
    }

    // Handle pattern validation (only for string/number)
    if (
        validation.pattern &&
        value &&
        typeof value === "string" &&
        !validation.pattern.test(value)
    ) {
        return validation.message || "Invalid input";
    }

    return null;
};

const START_MONTH = 11; // November
const START_YEAR = 2025;

export const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];

export const monthNamesHi = [
    "जनवरी",
    "फ़रवरी",
    "मार्च",
    "अप्रैल",
    "मई",
    "जून",
    "जुलाई",
    "अगस्त",
    "सितंबर",
    "अक्टूबर",
    "नवंबर",
    "दिसंबर"
];

export const getMonthYearOptions = (isHindi = false) => {
    const now = new Date();
    const currentMonth = now.getMonth() + 1; // JS month (0–11)
    const currentYear = now.getFullYear();

    const options = [];

    let year = START_YEAR;
    let month = START_MONTH;

    while (
        year < currentYear ||
        (year === currentYear && month <= currentMonth)
    ) {
        const monthLabel = isHindi ? monthNamesHi[month - 1] : monthNames[month - 1];
        options.push({
            label: `${monthLabel} ${year}`,
            value: `${month},${year}`
        });

        month++;
        if (month > 12) {
            month = 1;
            year++;
        }
    }

    return options;
};

export const parseJSONSafe = (value, fallback = []) => {
    if (!value) return fallback;
    if (Array.isArray(value)) return value;
    try {
        return JSON.parse(value);
    } catch {
        return fallback;
    }
};